module.exports = __webpack_public_path__ + "assets/img/btn-back-68a8a70b.png";